import { MINUTES_IN_A_DAY } from '../constants/timeConstants';

const convertMinutesToIsoDuration = (durationInMinutes: number | undefined): string | undefined => {
    if (durationInMinutes === undefined) {
        return;
    }
    if (durationInMinutes === 0) {
        return 'PT0M';
    }

    let isNegative = false;
    let duration = durationInMinutes;
    if (duration < 0) {
        isNegative = true;
        duration = -duration;
    }

    const days = Math.floor(duration / MINUTES_IN_A_DAY);
    const hours = Math.floor((duration % MINUTES_IN_A_DAY) / 60);
    const minutes = duration % 60;

    let isoDuration = `${isNegative ? '-' : ''}P`;
    if (days > 0) {
        isoDuration += `${days}D`;
    }
    if (hours > 0 || minutes > 0) {
        isoDuration += 'T';
        if (hours > 0) {
            isoDuration += `${hours}H`;
        }
        if (minutes > 0) {
            isoDuration += `${minutes}M`;
        }
    }

    return isoDuration;
};

export default convertMinutesToIsoDuration;
